'use client'

import React from 'react'
import Image from 'next/image'

export const ORBYT_MARK_SRC = '/brand/orbyt-mark.png'
export const ORBYT_WORDMARK_SRC = '/brand/orbyt-wordmark.png'

interface OrbytMarkProps {
  /** Compact orbital mark only (auth headers, shell). */
  size?: number
  className?: string
  /** Decorative — hide from AT when paired with visible “Orbyt” text. */
  decorative?: boolean
}

/** Orbyt orbital mark — use on auth, onboarding, and shell surfaces. */
export function OrbytMark({
  size = 44,
  className = '',
  decorative = true,
}: OrbytMarkProps) {
  return (
    <Image
      src={ORBYT_MARK_SRC}
      alt={decorative ? '' : 'Orbyt'}
      width={136}
      height={118}
      priority
      className={`h-auto w-auto object-contain ${className}`.trim()}
      style={{ width: size, height: 'auto' }}
      aria-hidden={decorative || undefined}
    />
  )
}

interface OrbytWordmarkProps {
  height?: number
  className?: string
}

/** Full Orbyt mark + wordmark lockup. */
export function OrbytWordmark({ height = 36, className = '' }: OrbytWordmarkProps) {
  return (
    <Image
      src={ORBYT_WORDMARK_SRC}
      alt="Orbyt"
      width={380}
      height={138}
      priority
      className={`h-auto w-auto object-contain ${className}`.trim()}
      style={{ height, width: 'auto' }}
    />
  )
}
